export default __webpack_public_path__ + "static/media/ch4_ukghg_map_production_20170101T00.831ef05b.png";